export default function StaffInterviewAccordion() {
  const items = document.querySelectorAll('[data-js="staff-interview-accordion-item"]');

  if (!items.length) {
    return;
  }

  items.forEach((item) => {
    if (item.dataset.accordionInitialized === 'true') {
      return;
    }

    const summary = item.querySelector('[data-js="staff-interview-accordion-trigger"]');
    const content = item.querySelector('[data-js="staff-interview-accordion-content"]');

    if (!(summary instanceof HTMLElement) || !(content instanceof HTMLElement)) {
      return;
    }

    item.dataset.accordionInitialized = 'true';

    if (item.open) {
      item.classList.add('is-open');
      content.style.height = 'auto';
      content.style.opacity = '1';
    } else {
      item.classList.remove('is-open');
      content.style.height = '0px';
      content.style.opacity = '0';
    }

    let isAnimating = false;

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (isAnimating) {
        return;
      }

      isAnimating = true;

      if (item.open) {
        item.classList.remove('is-open');
        content.style.height = `${content.scrollHeight}px`;
        content.style.opacity = '1';
        void content.offsetHeight;
        content.style.height = '0px';
        content.style.opacity = '0';

        const handleCloseEnd = (transitionEvent) => {
          if (transitionEvent.target !== content || transitionEvent.propertyName !== 'height') {
            return;
          }

          content.removeEventListener('transitionend', handleCloseEnd);
          item.open = false;
          isAnimating = false;
        };

        content.addEventListener('transitionend', handleCloseEnd);

        return;
      }

      item.open = true;
      item.classList.add('is-open');
      content.style.height = '0px';
      content.style.opacity = '0';
      void content.offsetHeight;
      content.style.height = `${content.scrollHeight}px`;
      content.style.opacity = '1';

      const handleOpenEnd = (transitionEvent) => {
        if (transitionEvent.target !== content || transitionEvent.propertyName !== 'height') {
          return;
        }

        content.removeEventListener('transitionend', handleOpenEnd);
        content.style.height = 'auto';
        isAnimating = false;
      };

      content.addEventListener('transitionend', handleOpenEnd);
    });
  });
}
